import { defineNuxtPlugin } from '#imports'
import { usePlayerService } from '@composables/use-player-service'
import { useQueueService } from '@composables/use-queue-service'
import { useQueueStore } from '@stores/queue'
import { useFavoritesStore } from '@stores/favorites'

declare global {
    interface Window {
        Cypress?: unknown
        __e2e__?: Record<string, unknown>
    }
}

// Cypress Testing Support
//
// A named surface rather than the app instance: the E2E suite used to reach
// through `__app__.$store` into Vuex, which no longer exists. Expose only what
// the specs actually need, so this stays honest about its own coupling.
export default defineNuxtPlugin({
    name: 'e2e',
    setup(nuxtApp) {
        if (!window.Cypress) return

        window.__e2e__ = {
            router: nuxtApp.$router,
            playerService: nuxtApp.runWithContext(usePlayerService),
            queueService: nuxtApp.runWithContext(useQueueService),
            // A read-only snapshot, not the store: specs assert on what the queue
            // holds, and nothing outside the app should be able to write to it.
            getQueue: () => ({ ...useQueueStore().$state }),
            // Favourites need writes, not just reads: the UI that sets them lives
            // on a `:hover`-gated resource cover, which no browser automation can
            // reach. Specs arrange state through these and then assert on what the
            // real Your Library and /radio/favorites pages render.
            favourites: {
                add: (type, id) => useFavoritesStore().add({ type, id }),
                remove: (type, id) => useFavoritesStore().remove({ type, id }),
                toggleChannel: id => useFavoritesStore().toggleChannel(id),
                channelIds: () => [...useFavoritesStore().channelIds],
            },
        }
    },
})
